import { render, staticRenderFns } from "./ShakaPlayer.vue?vue&type=template&id=5ddd32b4&scoped=true&"
import script from "./ShakaPlayer.vue?vue&type=script&lang=js&"
export * from "./ShakaPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddd32b4",
  null
  
)

export default component.exports